module.exports = __webpack_public_path__ + "assets/img/welcome_1.769d33cb.png";